<template>
    <div class="table-download-wrapper">
        <h4>Download as:</h4>
        <div class="button-row">
            <prime-button class="plain-btn" :disabled="props.disabled" @click="downloadCsv">
                <font-awesome-icon :icon="['fas', 'file-csv']" />
                CSV
            </prime-button>
            <download-excel
                type="xlsx"
                :name="`${props.fileName}.xlsx`"
                :fetch="props.formatFunction"
            >
                <prime-button v-tooltip="'Download Excel'" class="plain-btn" :disabled="props.disabled" @click="exit">
                    <font-awesome-icon :icon="['fas', 'file-excel']" />
                    Excel
                </prime-button>
            </download-excel>
        </div>
    </div>
</template>

<script lang="ts" setup generic="T extends any">
import PrimeButton from 'primevue/button';
import { exportCsv } from '@/utils/CsvExport.ts';

const props = defineProps<{
    fileName: string;
    formatFunction:() => Array<T>;
    disabled?: boolean;
}>();

const emit = defineEmits<{
    'exit': [];
}>();

function downloadCsv (): void {
    const data = props.formatFunction();
    if (!data || data.length === 0) return;

    const fields = Object.keys(data[0] as Record<string, never>);
    const headerRow = fields;

    const dataRows = data.map((row) => fields.map((field) => {
        const cellValue = (row as Record<string, never>)[field];
        return cellValue != null ? String(cellValue) : '';
    }));

    const allRows = [headerRow, ...dataRows];
    exportCsv(allRows, props.fileName);
    exit();
}

function exit (): void {
    emit('exit');
}

</script>

<style lang="scss" scoped>

.table-download-wrapper {
    padding: var(--defaultSpacing);
    display: flex;
    flex-direction: column;
    gap: var(--defaultSpacing);
    background: var(--neutral0);
    border-radius: var(--borderRadiusOuter);
}

.button-row {
    align-items: center;
    color: var(--lcpBlue);
    display: flex;
    gap: var(--defaultSpacing);
}

</style>
